(() => {
  const titlePattern = /Marco(?:['’]s|s) Signature Bolognese/gi;
  const reviewSelector = '[data-oke-reviews-widget], [data-oke-widget], .okeReviews, .oke-w, .okeReviews-review, [data-oke-review-id]';
  const retiredReviewNames = /George Calombaris|Manu Feildel|Silvia Colloca|Christine Manfield|Justin Narayan|Anna Polyviou|Gary Mehigan|Luke Nguyen|Marco Pierre White|\b(?:Marco|George|Manu|Silvia|Christine|Justin|Anna|Gary|Luke)[’']s\b|\bMr[.]? White\b/i;
  const filterRetiredChefReviews = () => {
    document.querySelectorAll('li.oke-w-reviews-list-item').forEach(review => {
      const content = review.textContent + ' ' + [...review.querySelectorAll('img[alt]')].map(image => image.alt).join(' ');
      review.toggleAttribute('data-providoor-retired-chef-review', retiredReviewNames.test(content));
    });
  };
  const cleanTextNode = node => {
    const parent = node.parentElement;
    if (!parent || parent.closest('script, style, textarea, [contenteditable], ' + reviewSelector)) return;
    const revised = node.nodeValue.replace(titlePattern, 'Signature Bolognese');
    if (revised !== node.nodeValue) node.nodeValue = revised;
  };
  const cleanImageAlt = image => {
    if (image.closest(reviewSelector)) return;
    const revised = image.alt.replace(titlePattern, 'Signature Bolognese')
      .replace(/ by Marco Pierre White/gi, '')
      .replace(/Marco Pierre White(?:['’]s)?\s*/gi, '')
      .replace(/Marco(?:['’]s|s)\s+/gi, '');
    if (image.alt !== revised) image.alt = revised;
  };
  const clean = root => {
    if (root.nodeType === Node.TEXT_NODE) { cleanTextNode(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(reviewSelector)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) cleanTextNode(node);
    if (root.matches('img[alt]')) cleanImageAlt(root);
    root.querySelectorAll('img[alt]').forEach(cleanImageAlt);
  };
  filterRetiredChefReviews();
  if (document.body) clean(document.body);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'characterData') cleanTextNode(record.target);
      else record.addedNodes.forEach(clean);
    });
    filterRetiredChefReviews();
  }).observe(document.documentElement, {childList: true, subtree: true, characterData: true});
})();
